import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { FileSearch, Check, X, AlertCircle } from "lucide-react";
import { toast } from "sonner";

export default function AdminApplications() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("submitted");
  const refresh = async () => {
    try {
      // Get all statuses
      const [s, r, i] = await Promise.all([
        api.get("/managers/?status=submitted"),
        api.get("/managers/?status=in_review"),
        api.get("/managers/?status=interview"),
      ]);
      // combine all + dedupe
      const all = [...s.data, ...r.data, ...i.data];
      setItems(all);
    } catch (e) { console.error(e); }
  };
  useEffect(() => { refresh(); }, []);
  const filtered = items.filter(m => m.application_status === tab);

  const updateStatus = async (id, status, notes) => {
    try {
      await api.put(`/managers/${id}/approval`, { status, admin_notes: notes });
      toast.success("Stato aggiornato");
      refresh();
    } catch (e) { toast.error("Errore"); }
  };

  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-1">Candidature manager</h1>
      <p className="text-sm text-slate-600 mb-4">Valida e approva i nuovi manager nel network.</p>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="submitted">Da rivedere</TabsTrigger>
          <TabsTrigger value="in_review">In revisione</TabsTrigger>
          <TabsTrigger value="interview">Colloquio</TabsTrigger>
        </TabsList>
        <TabsContent value={tab} className="mt-4 space-y-3">
          {filtered.length ? filtered.map(m => (
            <div key={m.id} className="cxo-card p-5">
              <div className="flex items-start gap-3">
                <img src={m.photo || "https://ui-avatars.com/api/?name=" + encodeURIComponent(m.user?.full_name || "M")} alt="" className="w-12 h-12 rounded-full object-cover" />
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="font-semibold text-slate-900">{m.user?.full_name}</h3>
                    <Badge variant="outline" className="text-xs">{m.application_status}</Badge>
                  </div>
                  <p className="text-sm text-slate-600">{m.title}</p>
                  <p className="text-xs text-slate-500 mt-1">Ruolo: {m.primary_role} · {m.years_managerial}+ anni</p>
                </div>
                <div className="flex gap-2">
                  <Button size="sm" onClick={() => updateStatus(m.id, "approved", "")} className="bg-[#1F9D6A] text-white" data-testid={`approve-mgr-${m.id}`}><Check size={14} className="mr-1" /> Approva</Button>
                  <Button size="sm" variant="outline" onClick={() => updateStatus(m.id, "in_review", "")}>In revisione</Button>
                  <Button size="sm" variant="destructive" onClick={() => updateStatus(m.id, "rejected", "")}><X size={14} className="mr-1" /> Rifiuta</Button>
                </div>
              </div>
            </div>
          )) : <div className="cxo-card p-8 text-center text-slate-500">Nessuna candidatura in stato {tab}.</div>}
        </TabsContent>
      </Tabs>
    </div>
  );
}
